<template>
	<div style="background-color: #fff;margin: 10px;border-radius: 3px;">
		<div style="position: sticky;top:0;z-index: 999;background-color: #fff;padding-bottom: 1px;border-bottom: 1px solid #ebeef5;padding-top: 10px;">
			<!--带折叠的搜索start-->
			<div>
				<el-form size="mini" style="display: flex;flex-wrap: wrap;padding-left: 8px;" :style="{'height':isShowCollapse?'auto':'50px'}" ref="searchForm" :model="searchForm" inline label-width="150px">

					<!--收起时显示的搜索项start 4个搜索项为一行-->
					<div v-show="!isShowCollapse" style="width: 80%;display: flex;">

						<el-form-item v-if="role=='hq_admin'" label="门店" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>

						<el-form-item label="课评状态" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.status" clearable placeholder="请选择">
								<!-- 状态 (0: 待审核, 1: 通过, 2: 驳回) -->
								<el-option label="待审核" :value="0" />
								<el-option label="审核通过" :value="1" />
								<el-option label="审核驳回" :value="2" />
							</el-select>
						</el-form-item>

						<el-form-item label="视频状态" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.video_status" clearable placeholder="请选择">
								<!-- 状态 (0: 待审核, 1: 通过, 2: 驳回) -->
								<el-option label="待审核" :value="0" />
								<el-option label="审核通过" :value="1" />
								<el-option label="审核驳回" :value="2" />
							</el-select>
						</el-form-item>

						<el-form-item v-if="!isMobile" label="手机号" style="width: 25%;display: flex;">
							<el-input v-model="searchForm.mobile" placeholder="请输入手机号" clearable size="mini" />
						</el-form-item>


					</div>
					<!--收起时显示的搜索项end-->

					<!--展开时显示的搜索项start 4个搜索项为一行-->
					<div v-if="isShowCollapse" style="display: flex;flex-wrap: wrap;">


						<el-form-item v-if="role=='hq_admin'" label="门店" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>



						<el-form-item label="课评状态" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.status" clearable placeholder="请选择">
								<!-- 状态 (0: 待审核, 1: 通过, 2: 驳回) -->
								<el-option label="待审核" :value="0" />
								<el-option label="审核通过" :value="1" />
								<el-option label="审核驳回" :value="2" />
							</el-select>
						</el-form-item>

						<el-form-item label="视频状态" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.video_status" clearable placeholder="请选择">
								<!-- 状态 (0: 待审核, 1: 通过, 2: 驳回) -->
								<el-option label="待审核" :value="0" />
								<el-option label="审核通过" :value="1" />
								<el-option label="审核驳回" :value="2" />
							</el-select>
						</el-form-item>

						<el-form-item label="手机号" style="width: 25%;display: flex;">
							<el-input v-model="searchForm.mobile" placeholder="请输入手机号" clearable size="mini" />
						</el-form-item>



						<el-form-item label="ETM姓名" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.etm_name" placeholder="请输入ETM姓名" clearable size="mini" />
						</el-form-item>

						<el-form-item label="ETM昵称" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.etm_nickname" placeholder="请输入ETM昵称" clearable size="mini" />
						</el-form-item>

						<!-- admin_id -->
						<el-form-item v-if="role=='store_admin'||role=='store_sa'" label="教练id" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.admin_id" clearable placeholder="请选择">



								<el-option v-for="item in storeAdminUserList" :label="item.nickname" :value="item.id">

									<div style="display: flex;align-items: center;">
										<img :src="item.avatar" style="width: 30px;height: 30px;margin-right: 10px;border-radius: 50%;" />
										<span style="float: left">{{ item.nickname }}</span>
									</div>


								</el-option>

							</el-select>
						</el-form-item>


						<!-- <el-form-item label="新增评论" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.new_remark" clearable placeholder="请选择">

								<el-option label="是" :value="1">是</el-option>
								<el-option label="否" :value="0">否</el-option>

							</el-select>
						</el-form-item> -->


						<!-- 原来是width:25% -->
						<el-form-item label="教学时间" style="width: 40%;display: flex;" label-width="115px">
							<div slot="label" style="width: 105px;text-align: right;">教学时间</div>
							<el-date-picker style="margin-left: 8px;" v-model="searchForm.school_time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
						</el-form-item>

						<el-form-item label="提交时间" style="width: 29%;display: flex;">
							<div slot="label" style="width: 105px;text-align: right;">提交时间</div>
							<el-date-picker style="margin-left: 8px;" v-model="searchForm.create_time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
						</el-form-item>

					</div>
					<!--展开时显示的搜索项end-->

					<div :style="{'width':isShowCollapse?'100%':'13%','justify-content': isShowCollapse?'flex-end':'center','margin-left':isMobile?'20px':'' }" style="height: 30px; display: flex;margin: 0;margin-bottom: 10px;">
						<div style="flex-shrink: 0;margin-right: 20px;display: flex;justify-content: center;align-items: center;cursor:pointer;color: #9A7E9C;font-size: 14px;line-height: 20px; display: flex;margin-left: 20px;" @click="isShowCollapseF()">
							<span v-if="!isShowCollapse">展开</span>
							<span v-else>收起</span>
							<span style="margin-left: 5px;font-size: 20px;line-height: 20px;" :style="{transform:isShowCollapse?'rotate(180deg)':'rotate(0deg)'}">∨</span>
						</div>
						<el-button round style="margin-right: 10px;" @click="handleSearch" type="primary" icon="el-icon-search" size="small">搜索</el-button>
						<el-button round @click="handleReset" size="small">重置</el-button>
						<div v-if="isShowCollapse" style="width: 70px;"></div>
					</div>


				</el-form>
			</div>
			<!--带折叠的搜索end-->

			<!-- 只允许单选的排序start -->
			<div style="margin-top: 10px;display: flex;align-items: center;background-color: #fff;margin-bottom: 10px; justify-content: space-between;">

				<div style="margin-right: 20px;margin-left: 35px;display: flex;align-items: center;">
					<div>
						<el-button type="success" round size="mini" @click="handleReset">全部</el-button>
						<el-button style="margin-left: 20px;" type="primary" round size="mini" @click="kePingSh">课评待审核</el-button>
						<el-button style="margin-left: 20px;" type="warning" round size="mini" @click="shipinSh">视频待审核</el-button>
						<el-button style="margin-left: 20px;" type="warning" round size="mini" @click="pingLunSh">评论待查看</el-button>
						<el-button style="margin-left: 20px;" type="warning" round size="mini" @click="huiFuSh">评论待回复</el-button>
						<el-button style="margin-left: 20px;" type="warning" round size="mini" @click="exportXFnByHTML">导出数据</el-button>

					</div>

				</div>

				<div class="sortLine" style="font-size: 14px;display: inline-flex; margin-left: 40px; color: #6f6c5f;background-color: #e0f7ed;border-radius: 8px;overflow: hidden;margin-right: 68px;">

					<div class="sortItem dis" @click="sort(-1)" :style="{color: sortIndex==-1?'#fff':'#777','font-weight': sortIndex==-1?'bold':'400','background-color': sortIndex==-1?'#9E819F':''}">
						默认</div>
					<!-- 排序项start -->
					<div class="sortItem dis" @click="sort(0,'created_at')" :style="{color: sortIndex==0?'#fff':'#777','font-weight': sortIndex==0?'bold':'400','background-color': sortIndex==0?'#9E819F':''}">
						提交时间
						<img v-if="sortIndex==0&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==0&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					<!-- 排序项end -->
					<div class="sortItem dis" @click="sort(1,'remark_time')" :style="{color: sortIndex==1?'#fff':'#777','font-weight': sortIndex==1?'bold':'400','background-color': sortIndex==1?'#9E819F':''}">
						评论时间
						<img v-if="sortIndex==1&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==1&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>

				</div>


			</div>
			<!-- 只允许单选的排序end -->

		</div>





		<!--表格start :height="tableHeight+'px'"-->
		<el-table :height="tableHeight" :show-header="false" ref="table" :data="tableData" style="width: 100%;background-color: #fff;margin: 5px;">

			<el-table-column style="width: 100%;">
				<template slot-scope="{ row, index }">
					<div class="tableTem" style="display: flex;">


						<div class="avatar" style="padding-right: 0;">

							<!--用户图片start-->
							<div style="text-align: center;" class="dis">
								<img :src="row.user.avatar" style="width:70px;height:70px;cursor: pointer;" @click="handlePreView(row.user.avatar)">
								<!-- <div class="titleFont">主图</div> -->
							</div>
							<!--用户图片end-->

							<div style="width: 200px;">

								<!--头像右侧一个列表项start-->
								<div style="display: flex;">
									<span class="titleFont" style="width: 90px;text-align: right;">id：</span>
									<el-tooltip :content="row.id+''" placement="right">
										<div class="dian dianL">{{row.id}}</div>
									</el-tooltip>
								</div>
								<!--头像右侧一个列表项end-->
								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 90px;text-align: right;">微信名：</span>
									<el-tooltip :content="row.user.nickname" placement="right">
										<div class="dian dianL">{{row.user.nickname}}</div>
									</el-tooltip>
								</div>

								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 90px;text-align: right;">ETM昵称：</span>
									<el-tooltip :content="row.user.etm_nickname" placement="right">
										<div class="dian dianL">{{row.user.etm_nickname}}</div>
									</el-tooltip>
								</div>

								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 90px;text-align: right;">ETM姓名：</span>
									<el-tooltip :content="row.user.etm_name" placement="right">
										<div class="dian dianL">{{row.user.etm_name}}</div>
									</el-tooltip>
								</div>



								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 90px;text-align: right;">性别：</span>
									<el-tooltip :content="row.user.sex?(row.user.sex==1?'男':'女') :'未知' " placement="right">
										<div class="dian dianL">{{row.user.sex?(row.user.sex==1?'男':'女') :'未知' }}</div>
									</el-tooltip>
								</div>

								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 90px;text-align: right;">手机号：</span>
									<el-tooltip :content="row.user.mobile?row.user.mobile:'无'" placement="right">
										<div class="dian dianL">{{row.user.mobile?row.user.mobile:'无'}}</div>
									</el-tooltip>
								</div>


								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 90px;text-align: right;">课评状态：</span>

									<div v-if="row.status==0" class="dian dianL" style="color: #ff9900;font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
										<div style="width: 10px;height: 10px;background-color: #ff9900;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
										待审核
									</div>
									<div v-if="row.status==1" class="dian dianL" style="color: rgb(103, 194, 58);font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
										<div style="width: 10px;height: 10px;background-color: rgb(103, 194, 58);border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
										审核通过
									</div>


									<div v-if="row.status==2" class="dian dianL" style="color: red;font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
										<div style="width: 10px;height: 10px;background-color: red;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
										审核驳回
									</div>



								</div>

								<div style="display: flex;margin-top: -6px;">
									<span class="titleFont" style="width: 90px;text-align: right;">视频状态：</span>

									<div v-if="!row.video" class="dian dianL" style="color: #ff9900;font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
										<div style="width: 10px;height: 10px;background-color: #ff9900;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
										待提交
									</div>

									<div v-else-if="row.video_status==0" class="dian dianL" style="color: #ff9900;font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
										<div style="width: 10px;height: 10px;background-color: #ff9900;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
										待审核
									</div>
									<div v-else-if="row.video_status==1" class="dian dianL" style="color: rgb(103, 194, 58);font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
										<div style="width: 10px;height: 10px;background-color: rgb(103, 194, 58);border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
										审核通过
									</div>


									<div v-else-if="row.video_status==2" class="dian dianL" style="color: red;font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
										<div style="width: 10px;height: 10px;background-color: red;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
										审核驳回
									</div>



								</div>


							</div>
						</div>


						<!-- height: 50px; -->
						<ul :style="{'width':isMobile?mobileWidth+'px':'','overflow-x':isMobile?'auto':'','overflow-y':isMobile?'hidden':'','flex-wrap':isMobile?'nowrap':''}">




							<!-- <li style="width: 180px;">
								<div class="content dis" style="width: 180px;min-height: 40px;">
									<el-tooltip :content="row.store.name" placement="right" style="width: 180px;">
										<div class="dian" style="width: 180px;padding-left: 10px;padding-right: 10px;">{{row.store.name}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">门店名称</div>
							</li> -->
							
							<li >
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.store.name" placement="right" style="">
										<div class="dian" style="padding-left: 10px;padding-right: 10px;">{{row.store.name}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">门店名称</div>
							</li>

							<li>
								<div class="content dis" style="min-height: 40px;">

									<img :src="row.admin.avatar" style="width:30px;cursor: pointer;border-radius: 3px;" @click="handlePreView(row.admin.avatar)">

								</div>
								<div class="titleFont dian">教练头像</div>
							</li>
							<li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.admin.nickname" placement="right">
										<div class="dian">{{row.admin.nickname}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">教练昵称</div>
							</li>



							<li>
								<div class="content dis" style="min-height: 40px;">

									<!-- 1: 0-6, 2: 7-12, 3: 13-26, 4: 27-36, 5: 37- -->
									<div v-if="row.stage==1" class="dian">0-6月龄</div>
									<div v-if="row.stage==2" class="dian">7-12月龄</div>
									<div v-if="row.stage==3" class="dian">13-26月龄</div>
									<div v-if="row.stage==4" class="dian">27-36月龄</div>
									<div v-if="row.stage==5" class="dian">37月龄以上</div>

								</div>
								<div class="titleFont">月龄</div>
							</li>


							<li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.status_remark" placement="right">
										<div class="dian">{{row.status_remark?row.status_remark:'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">审核意见</div>
							</li>



							<li>

								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.view_count+''" placement="right">
										<div class="dian">{{row.view_count}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">阅读用户</div>
							</li>



							<li>

								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.remark_count+''" placement="right">
										<div class="dian">{{row.remark_count}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">评论数量</div>
							</li>

							<li>

								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.new_remark?row.new_remark+'':0+''" placement="right">
										<div class="dian">{{row.new_remark?row.new_remark:0}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">待读评论</div>
							</li>

							<li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.datetime+''" placement="right">
										<div class="content dis" style="flex-direction: column;line-height: 16px;">
											<div>{{row.datetime | timeBreak1}}</div>
											<div>{{row.datetime | timeBreak2}}</div>
										</div>

									</el-tooltip>
								</div>
								<div class="titleFont dian">教学时间</div>
							</li>

							<li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.duration+''" placement="right">
										<div class="content dis" style="flex-direction: column;line-height: 16px;">
											<div>{{row.duration | timeBreak1}}</div>
											<div>{{row.duration | timeBreak2}}</div>
										</div>

									</el-tooltip>
								</div>
								<div class="titleFont dian">教学时长</div>
							</li>



							<li>
								<div class="content dis" style="min-height: 40px;">
									<el-tooltip :content="row.created_at+''" placement="right">
										<div class="content dis" style="flex-direction: column;line-height: 16px;">
											<div :style="{'color':row.is_timeout==1?'red':''}">{{row.created_at | timeBreak1}}</div>
											<div :style="{'color':row.is_timeout==1?'red':''}">{{row.created_at | timeBreak2}}</div>
										</div>

									</el-tooltip>
								</div>
								<div class="titleFont dian" :style="{'color':row.is_timeout==1?'red':''}">提交时间</div>
							</li>

						</ul>


						<div v-if="(role=='store_admin'||role=='hq_admin')" style="width: 100px;display: flex;justify-content: start;align-items: center;margin-left: 10px;">
							<el-dropdown trigger="hover" style="width: 80px;">
								<el-button size="mini" round type="primary">
									操作<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">

									<el-dropdown-item>
										<el-button type="success" size="mini" round @click="showDetail(row)">查看
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item v-if="role=='store_admin'||role=='store_sa'">
										<el-button type="danger" size="mini" round @click="delSK(row.id)">删除
										</el-button>

									</el-dropdown-item>

									<!-- <el-dropdown-item v-if="role=='store_editor'">
										<el-button  v-if="row.status==0" type="danger" size="mini" round @click="showAddOrEdit(row,'edit')">编辑
										</el-button>
									</el-dropdown-item> -->








								</el-dropdown-menu>
							</el-dropdown>

						</div>




					</div>

				</template>
			</el-table-column>
		</el-table>
		<!--表格end-->

		<!--分页start-->
		<el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;padding-bottom: 10px;">
			<el-pagination background layout="prev, pager, next" :current-page="pageNumber" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
			<span style="font-size: 13px;color: #999;">共 {{total}} 条</span>
		</el-row>
		<!--表格end-->

		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" width="400px" title="预览" :visible.sync="isShowPreImg">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>
		<!--浏览图片的弹窗end-->


		<!--详情的弹窗start-->
		<el-dialog :close-on-click-modal="false" class="detal" width="70%" title="详情" :visible.sync="isShowDetail">
			<div v-if="isShowDetail" class="order-detail">

				<!-- 一行start -->
				<div class="title">用户信息</div>

				<div class="order-information " style="margin-bottom: 50px;">
					<!-- 一列start -->
					<div class="order-information-contentOne">
						<!-- 用户start -->
						<div class="contentOne-content">
							<div class="contentOne-content-title">微信头像：</div>
							<img :src="currentRow.user.avatar" style="margin-top: -10px; width: 50px;height: 50px;border-radius: 50%;cursor: pointer;margin-right: 10px;" @click="handlePreView(currentRow.user.avatar)" />
						</div>

						<div class="contentOne-content">
							<div class="contentOne-content-title">微信名称：</div>
							<div class="contentOne-content-text text-num">{{currentRow.user.nickname}}</div>

						</div>

						<div class="contentOne-content">
							<div class="contentOne-content-title">ETM姓名：</div>
							<div class="contentOne-content-text text-num">{{currentRow.user.etm_name}}</div>

						</div>

						<div class="contentOne-content">
							<div class="contentOne-content-title">ETM昵称：</div>
							<div class="contentOne-content-text text-num">{{currentRow.user.etm_nickname}}</div>

						</div>

						<div class="contentOne-content">
							<!-- 0: 未知, 1: 男, 2: 女 -->
							<div class="contentOne-content-title">用户性别：</div>
							<div v-if="currentRow.user.sex==0" class="contentOne-content-text text-num">未知</div>
							<div v-if="currentRow.user.sex==1" class="contentOne-content-text text-num">男</div>
							<div v-if="currentRow.user.sex==2" class="contentOne-content-text text-num">女</div>
						</div>

						<div class="contentOne-content">

							<div class="contentOne-content-title">课评状态：</div>
							<div v-if="currentRow.status==1" class="contentOne-content-text text-num">
								<div style="width: 10px;height: 10px;background-color: rgb(103, 194, 58);border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
								审核通过
							</div>
							<div v-if="currentRow.status==0" class="contentOne-content-text text-num">
								<div style="width: 10px;height: 10px;background-color: #ff9900 ;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
								待审核
							</div>

							<div v-if="currentRow.status==2" class="contentOne-content-text text-num">
								<div style="width: 10px;height: 10px;background-color: red ;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
								审核驳回
							</div>

						</div>


						<div class="contentOne-content">

							<div class="contentOne-content-title">视频状态：</div>

							<div v-if="!currentRow.video" class="contentOne-content-text text-num">
								<div style="width: 10px;height: 10px;background-color: #ff9900;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
								待提交
							</div>

							<div v-else-if="currentRow.video_status==1" class="contentOne-content-text text-num">
								<div style="width: 10px;height: 10px;background-color: rgb(103, 194, 58);border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
								审核通过
							</div>
							<div v-else-if="currentRow.video_status==0" class="contentOne-content-text text-num">
								<div style="width: 10px;height: 10px;background-color: #ff9900 ;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
								待审核
							</div>

							<div v-else-if="currentRow.video_status==2" class="contentOne-content-text text-num">
								<div style="width: 10px;height: 10px;background-color: red ;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
								审核驳回
							</div>

						</div>

						<div v-if="currentRow.status_remark" class="contentOne-content">
							<div class="contentOne-content-title">审核意见：</div>
							<div class="contentOne-content-text text-num">{{currentRow.status_remark?currentRow.status_remark:'无'}}</div>

						</div>



					</div>
					<!-- 一列start -->
					<!-- 一列start -->
					<div class="order-information-contentOne">
						<!-- 用户start -->
						<div class="contentOne-content">
							<div class="contentOne-content-title">教练头像：</div>
							<img :src="currentRow.admin.avatar" style="margin-top: -10px; width: 50px;height: 50px;border-radius: 50%;cursor: pointer;margin-right: 10px;" @click="handlePreView(currentRow.admin.avatar)" />
						</div>

						<div class="contentOne-content">
							<div class="contentOne-content-title">教练昵称：</div>
							<div class="contentOne-content-text text-num">{{currentRow.admin.nickname}}</div>

						</div>

						<div class="contentOne-content">
							<div class="contentOne-content-title">门店名称：</div>
							<div class="contentOne-content-text text-num">{{currentRow.store.name}}</div>

						</div>

					</div>
					<!-- 一列start -->

				</div>
				<!-- 一行end -->



				<!-- 一行start -->
				<div class="title">用户时刻</div>

				<div class="order-information " style="margin-bottom: 50px;width: 100%;">
					<!-- 一列start -->
					<div class="order-information-contentOne" style="width: 100%;">


						<div class="contentOne-content">
							<div class="contentOne-content-title">视频：</div>
							<!-- currentRow.video -->
							<video v-if="currentRow.video" :src="currentRow.video" style=" width: 250px;border-radius: 10px;margin-bottom: 10px;" controls />
							<div v-else class="contentOne-content-text text-num">无</div>
						</div>

						<div class="contentOne-content">
							<div class="contentOne-content-title">图片：</div>
							<img v-for="(item,index) in currentRow.images" :key="index" :src="item" style="width: 50px;height: 50px;border-radius: 6px;cursor: pointer;margin-right: 10px;" @click="handlePreView(item)" />

						</div>


						<div class="contentOne-content">
							<div class="contentOne-content-title">月龄：</div>

							<!-- 1: 0-6, 2: 7-12, 3: 13-26, 4: 27-36, 5: 37- -->
							<div v-if="currentRow.stage==1" class="contentOne-content-text text-num">0-6月龄</div>
							<div v-if="currentRow.stage==2" class="contentOne-content-text text-num">7-12月龄</div>
							<div v-if="currentRow.stage==3" class="contentOne-content-text text-num">13-26月龄</div>
							<div v-if="currentRow.stage==4" class="contentOne-content-text text-num">27-36月龄</div>
							<div v-if="currentRow.stage==5" class="contentOne-content-text text-num">37月龄以上</div>

						</div>

						<!-- 0-6月龄start -->
						<div v-if="currentRow.stage==1">

							<div class="contentOne-content">
								<div class="contentOne-content-title">适应能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[0])"></start>
									<div style="margin-top: 10px;">目标：在水中放松、爱笑</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title" style="margin-left: 14px;">大运动：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[1])"></start>
									<div style="margin-top: 10px;">目标：自主踢腿意识及划手动作</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">手眼协调：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[2])"></start>
									<div style="margin-top: 10px;">目标：手眼协调配合能够抓取小玩具</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">适水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[3])"></start>
									<div style="margin-top: 10px;">目标：适水放松，闭气2秒以上，有明显口令意识</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">潜水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[4])"></start>
									<div style="margin-top: 10px;">目标：适水放松，潜水2秒以上，有明显口令意识</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">仰漂能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[5])"></start>
									<div style="margin-top: 10px;">目标：仰漂放松，能独立仰漂</div>
								</div>
							</div>


							<div class="contentOne-content">
								<div class="contentOne-content-title">进阶计划：</div>
								<div class="contentOne-content-text text-num">

									<div>{{currentRow.contents[0]}}</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">在家练习：</div>
								<div class="contentOne-content-text text-num">

									<div>{{currentRow.contents[1]}}</div>
								</div>
							</div>


						</div>
						<!-- 0-6月龄end -->


						<!-- 7-12月龄start -->
						<div v-if="currentRow.stage==2">

							<div class="contentOne-content">
								<div class="contentOne-content-title">适应能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[0])"></start>
									<div style="margin-top: 10px;">目标：在水中放松、爱笑</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title" style="margin-left: 14px;">大运动：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[1])"></start>
									<div style="margin-top: 10px;">目标：自主踢腿意识及划手动作</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">精细动作：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[2])"></start>
									<div style="margin-top: 10px;">目标：按指令完成抓握动作</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">适水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[3])"></start>
									<div style="margin-top: 10px;">目标：适水放松，闭气2秒以上，有明显口令意识</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">潜水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[4])"></start>
									<div style="margin-top: 10px;">目标：适水放松，潜水3秒以上，有明显口令意识，能独立潜水1秒</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title" style="margin-left: -1em;">指令完成度：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[5])"></start>
									<div style="margin-top: 10px;">目标：根据指令完成动作，理解指令</div>
								</div>
							</div>


							<div class="contentOne-content">
								<div class="contentOne-content-title">进阶计划：</div>
								<div class="contentOne-content-text text-num">

									<div>{{currentRow.contents[0]}}</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">在家练习：</div>
								<div class="contentOne-content-text text-num">

									<div>{{currentRow.contents[1]}}</div>
								</div>
							</div>


						</div>
						<!-- 7-12月龄end -->




						<!-- 13-26月龄start -->
						<div v-if="currentRow.stage==3">

							<div class="contentOne-content">
								<div class="contentOne-content-title">适应能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[0])"></start>
									<div style="margin-top: 10px;">目标：在水中放松、爱笑</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title" style="margin-left: 14px;">大运动：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[1])"></start>
									<div style="margin-top: 10px;">目标：自主踢腿意识，有直膝交错踢腿动作</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title" style="margin-left: -1em;">指令完成度：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[2])"></start>
									<div style="margin-top: 10px;">目标：根据指令完成动作，理解指令</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">适水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[3])"></start>
									<div style="margin-top: 10px;">目标：适水放松，闭气5秒以上，有明显口令意识</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">潜水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[4])"></start>
									<div style="margin-top: 10px;">目标：适水放松，潜水3秒以上，有明显口令意识，能独立潜水2秒</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">认知能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[5])"></start>
									<div style="margin-top: 10px;">目标：认识简单的色彩、数字</div>
								</div>
							</div>


							<div class="contentOne-content">
								<div class="contentOne-content-title">进阶计划：</div>
								<div class="contentOne-content-text text-num">

									<div>{{currentRow.contents[0]}}</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">在家练习：</div>
								<div class="contentOne-content-text text-num">

									<div>{{currentRow.contents[1]}}</div>
								</div>
							</div>


						</div>
						<!-- 13-26月龄end -->





						<!-- 27-36月龄start -->
						<div v-if="currentRow.stage==4">

							<div class="contentOne-content">
								<div class="contentOne-content-title">适应能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[0])"></start>
									<div style="margin-top: 10px;">目标：在水中放松、与教练表达意愿</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">踢腿动作：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[1])"></start>
									<div style="margin-top: 10px;">目标：直膝交错踢腿动作</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">呼吸控制：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[2])"></start>
									<div style="margin-top: 10px;">目标：稳定的进行吐泡泡，适水闭气5秒</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">身体控制：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[3])"></start>
									<div style="margin-top: 10px;">目标：手持A板进行自主抬头换气</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">安全自救：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[4])"></start>
									<div style="margin-top: 10px;">目标：有应激闭气动作，能够在水中进行自救上岸</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">划手能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[5])"></start>
									<div style="margin-top: 10px;">目标：直臂划手配合游进</div>
								</div>
							</div>
							<div class="contentOne-content">
								<div class="contentOne-content-title">配合练习：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[6])"></start>
									<div style="margin-top: 10px;">目标：潜水游进配合划手转头换气</div>
								</div>
							</div>


							<div class="contentOne-content">
								<div class="contentOne-content-title">进阶计划：</div>
								<div class="contentOne-content-text text-num">

									<div>{{currentRow.contents[0]}}</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">在家练习：</div>
								<div class="contentOne-content-text text-num">

									<div>{{currentRow.contents[1]}}</div>
								</div>
							</div>


						</div>
						<!-- 27-36月龄end -->





						<!-- 37月龄以上start -->
						<div v-if="currentRow.stage==5">

							<div class="contentOne-content">
								<div class="contentOne-content-title">适应能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[0])"></start>
									<div style="margin-top: 10px;">目标：能独立完成任务，接受自己的成功和失败</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">踢腿动作：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[1])"></start>
									<div style="margin-top: 10px;">目标：直膝交错踢腿配合潜水游进</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">呼吸控制：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[2])"></start>
									<div style="margin-top: 10px;">目标：稳定进行换气，适水闭气8秒</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">身体控制：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[3])"></start>
									<div style="margin-top: 10px;">目标：手持A板进行自主抬头换气</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">安全自救：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[4])"></start>
									<div style="margin-top: 10px;">目标：有应激闭气动作，能够在水中进行自救上岸</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">划手能力：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[5])"></start>
									<div style="margin-top: 10px;">目标：直臂划手配合游进</div>
								</div>
							</div>
							<div class="contentOne-content">
								<div class="contentOne-content-title">配合练习：</div>
								<div class="contentOne-content-text text-num">
									<start :startTotal="Number(currentRow.scores[6])"></start>
									<div style="margin-top: 10px;">目标：潜水游进配合划手转头换气</div>
								</div>
							</div>


							<div class="contentOne-content">
								<div class="contentOne-content-title">进阶计划：</div>
								<div class="contentOne-content-text text-num">

									<div>{{currentRow.contents[0]}}</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title">在家练习：</div>
								<div class="contentOne-content-text text-num">

									<div>{{currentRow.contents[1]}}</div>
								</div>
							</div>


						</div>
						<!-- 37月龄以上end -->






						<div class="contentOne-content">
							<div class="contentOne-content-title">教学时间：</div>
							<div class="contentOne-content-text text-num">{{currentRow.datetime}}</div>
						</div>
						<div class="contentOne-content">
							<div class="contentOne-content-title">教学时长：</div>
							<div class="contentOne-content-text text-num">{{currentRow.duration}}</div>
						</div>
						<div class="contentOne-content">
							<div :style="{'color':currentRow.is_timeout==1?'red':''}" class="contentOne-content-title">提交时间：</div>
							<div :style="{'color':currentRow.is_timeout==1?'red':''}" class="contentOne-content-text text-num">{{currentRow.created_at}}</div>
						</div>


						<!-- 评论列表start -->
						<div class="contentOne-content">
							<div class="contentOne-content-title">阅读用户：</div>

						</div>

						<div v-if="currentRow.users.length==0" style="color:#aaa;font-size: 13px;margin-left: 55px;margin-bottom: 10px;">暂无信息~</div>

						<div class="contentOne-content">
							<div style="display: flex;flex-wrap: wrap;">
								<img v-for="(item,index) in currentRow.users" :src="item.avatar" style="flex-shrink: 0; width: 40px;height: 40px;background: #DDDDDD;border-radius: 50%;margin-right:10px;margin-bottom: 10px;"></img>
							</div>
						</div>

						<div class="contentOne-content">
							<div class="contentOne-content-title">用户评论：</div>

						</div>

						<div v-if="currentRow.remark.length==0" style="color:#aaa;font-size: 13px;margin-left: 55px;margin-bottom: 10px;">暂无信息~</div>










						<!-- 评论列表start -->
						<div style="margin-left: 1em;">


							<div v-for="(item,index) in currentRow.remark">



								<!-- 评论start -->
								<div>
									<div class="dis" style="margin-bottom: 10px;justify-content: flex-start;margin-top: 20px;">

										<img v-if="item.user" :src="item.user.avatar" style="flex-shrink: 0;width: 30px;height: 30px;background: #DDDDDD;border-radius: 50%;margin-right:10px;"></img>
										<img v-if="item.admin" :src="item.admin.avatar" style="flex-shrink: 0;width: 30px;height: 30px;background: #DDDDDD;border-radius: 50%;margin-right:10px;"></img>


										<div style="display: flex;justify-content: space-between;width: 100%;padding-right: 10px;">
											<div style="display: flex;align-items: center;">
												<div v-if="item.user" style="font-family: Source Han Sans CN;font-weight: 500; color: rgb(164, 164, 164);">{{item.user.nickname}}</div>
												<div v-if="item.admin" style="font-family: Source Han Sans CN;font-weight: 500; color: rgb(164, 164, 164);">{{item.admin.nickname}}</div>

												<div v-if="item.reply_user||item.reply_admin" style="display: flex;align-items: center;">

													<div style="margin-left: 10px;margin-right: 10px; color: rgb(164, 164, 164);">回复</div>
													<!-- <img v-if="item.reply_user" :src="item.reply_user.avatar" style="flex-shrink: 0;width: 30px;height: 30px;background: #DDDDDD;border-radius: 50%;margin-right:25px;"></img>
														<img v-if="item.reply_admin" :src="item.reply_admin.avatar" style="flex-shrink: 0;width: 30px;height: 30px;background: #DDDDDD;border-radius: 50%;margin-right:25px;"></img>
 -->
													<div v-if="item.reply_user" style="font-family: Source Han Sans CN;font-weight: 500; color: rgb(164, 164, 164);">{{item.reply_user.nickname}}</div>
													<div v-if="item.reply_admin" style="font-family: Source Han Sans CN;font-weight: 500; color: rgb(164, 164, 164);">{{item.reply_admin.nickname}}</div>

												</div>

											</div>




										</div>
									</div>


									<div style="margin-left:40px; width: 570px; color: rgb(164, 164, 164);display: flex;align-items: flex-end;justify-content: space-between;">

										{{item.remark}}
									</div>

									<div style="margin-left:40px;display: flex;justify-content: space-between;align-items: center;margin-top: 10px;">
										<div style="font-size: 13px; font-family: Source Han Sans CN;font-weight: 400; color: rgb(164, 164, 164);flex-shrink: 0;">{{item.created_at}}</div>

										<div @click="showPingLunPop(item)" style="flex-shrink: 0; color: rgb(164, 164, 164);padding-right: 20px;cursor: pointer;">回复</div>

									</div>
								</div>
								<!-- 评论end -->









							</div>


						</div>



						<div class="dis" style="justify-content: flex-start;margin-left: 50px;margin-top: 40px;">
							<el-input type="textarea" autosize placeholder="请输入评论" v-model="pingLunByAdmin" style="border-radius: 10px;padding: 5px;width:40%;" />

							<div @click="sendMsg" class="dis" style="flex-shrink: 0; margin-left: 10px; color:#fff; cursor: pointer;  width: 60px;height: 30px;background: #907897;border-radius: 10px;">发送</div>

						</div>
























					</div>
					<!-- 一列start -->


				</div>
				<!-- 一行end -->


				<div v-if="(role=='store_admin'||role=='store_sa')&&(currentRow.status==0||currentRow.status==2||currentRow.video_status==0||currentRow.video_status==2)">

					<div style="display: flex;justify-content: flex-end;align-items: center;  margin-bottom: 20px;">
						<span style="color: rgb(164, 164, 164);margin-right: 10px;">审核意见：</span>
						<el-input style="width:50%" v-model="currentRow.status_remark" placeholder="请输入审核意见"></el-input>
					</div>
					<div style="display: flex;justify-content: flex-end;">


						<div v-if="(role=='store_admin'||role=='store_sa')&&( (currentRow.status==0||currentRow.status==2) || (currentRow.video &&(currentRow.video_status==0||currentRow.video_status==2)) )" class="dis" style="justify-content: flex-end;">

							<el-button style="margin-left: 20px;" type="success" size="mini" round @click="yiJianShenheTgVideo(currentRow.id)">一键通过
							</el-button>



						</div>

						<div v-if="(role=='store_admin'||role=='store_sa')&&(currentRow.status==0||currentRow.status==2)" class="dis" style="justify-content: flex-end;">

							<el-button style="margin-left: 20px;" type="success" size="mini" round @click="shenheTg(currentRow.id,1)">课评通过
							</el-button>

							<el-button style="margin-left: 20px;" type="danger" size="mini" round @click="shenheTg(currentRow.id,2)">课评驳回
							</el-button>



						</div>



						<!-- 视频审核start -->
						<div v-if="(role=='store_admin'||role=='store_sa') && currentRow.video &&(currentRow.video_status==0||currentRow.video_status==2)" class="dis" style="justify-content: flex-end;">

							<el-button style="margin-left: 20px;" type="success" size="mini" round @click="shenheTgVideo(currentRow.id,1)">视频通过
							</el-button>

							<el-button style="margin-left: 20px;" type="danger" size="mini" round @click="shenheTgVideo(currentRow.id,2)">视频驳回
							</el-button>

						</div>
						<!-- 视频审核end -->
					</div>

				</div>

			</div>

		</el-dialog>
		<!--详情的弹窗end-->


		<!-- 回复的输入框sart -->
		<!-- :modal="false" -->
		<el-dialog :close-on-click-modal="false" width="35%" :title="pingLunInputPlaValue" :visible.sync="isShowPingLunPop" @close="onPingLunPopClose">
			<div style="display: flex;align-items: center;">

				<el-input type="textarea" autosize autofocus :placeholder="pingLunInputPlaValue" v-model="pingLunInputValue" style="border-radius: 10px;padding: 5px;width:80%;" />

				<div @click="sendHuifu" class="dis" style="flex-shrink: 0; margin-left: 10px; color:#fff; cursor: pointer;  width: 60px;height: 30px;background: #907897;border-radius: 10px;">发送</div>

			</div>
		</el-dialog>

		<!-- 回复的输入框end -->



		<!-- 添加弹窗start -->
		<el-dialog :close-on-click-modal="false" @close="addXueClose" class="detal" center width="80%" title="查询学员上课记录" :visible.sync="isShowAdd">
			<div class="dis" style="margin-bottom: 10px;">

				手机号：<el-input type="number" style="width: 200px;" size="mini" v-model="xueMobile" placeholder="请输入学员手机号"></el-input>
				<el-button round style="margin-left: 20px;" @click="xueMobileBySearch" type="primary" icon="el-icon-search" size="small">查询</el-button>
			</div>
			<el-table :header-row-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" :row-style="{'text-align':'center'}" :data="xueListTable" style="width: 100%;margin-bottom: 30px;">
				<el-table-column label="用户名称" width="180">
					<template slot-scope="scope">

						<span style="margin-left: 10px">{{ scope.row.name }}</span>
					</template>
				</el-table-column>
				<el-table-column label="教材名称" width="180">
					<template slot-scope="scope">

						<span style="margin-left: 10px">{{ scope.row.course }}</span>
					</template>
				</el-table-column>

				<el-table-column label="课程名称" width="180">
					<template slot-scope="scope">

						<span style="margin-left: 10px">{{ scope.row.lesson }}</span>
					</template>
				</el-table-column>

				<el-table-column label="上课状态" width="180">
					<template slot-scope="scope">

						<span style="margin-left: 10px">{{ scope.row.status }}</span>
					</template>
				</el-table-column>
				<el-table-column label="上课时间" width="210">
					<template slot-scope="scope">

						<span style="margin-left: 10px">{{ scope.row.date }}</span>
					</template>
				</el-table-column>



				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="primary" round size="mini" @click="showAddOrEdit(scope.row,'add')">添加时刻</el-button>

					</template>
				</el-table-column>
			</el-table>



		</el-dialog>
		<!-- 添加弹窗end -->

		<!--添加或修改的弹窗start-->
		<el-dialog :close-on-click-modal="false" @close="andOrEidtXueClose" center class="detal" width="60%" title="信息" :visible.sync="isShowAddOrEdit">
			<div v-if="isShowAddOrEdit" style="padding-left: 50px;" class="order-detail">


				<!-- 一行start -->


				<div class="order-information " style="margin-bottom: 50px;width: 100%;">
					<!-- 一列start -->
					<div class="order-information-contentOne" style="width: 100%;">


						<div class="contentOne-content">
							<div class="contentOne-content-title" style="margin-left: 23px;"><span style="color: transparent;">*</span>视频：</div>
							<upload-video :videoShowWidth="250" :limit="1" ref="xueAddVideoFormRef" :videoList="xueAddVideoForm" style="margin-top: -10px;"></upload-video>

						</div>

						<div class="contentOne-content">
							<div class="contentOne-content-title" style="margin-left: 23px;"><span style="color: red;">*</span>图片：<div style="font-size: 12px;margin-top: 5px;margin-left: -10px;">240*160</div>
							</div>

							<upload-img :limit="20" :imgWidth="240" :imgHeight="160" ref="xueAddImgFormRef" :imgList="xueAddImgForm"></upload-img>

						</div>


						<div class="contentOne-content" style="margin-bottom: 20px;">
							<div class="contentOne-content-title" style="margin-left: 23px;"><span style="color: red;">*</span> 月龄：</div>

							<!-- 1: 0-6, 2: 7-12, 3: 13-26, 4: 27-36, 5: 37- -->
							<el-select @change="yueLingChange" size="mini" v-model="xueAddYueLingForm" placeholder="请选择" style="margin-top: -5px;">
								<el-option label="0-6月龄" :value="1"></el-option>
								<el-option label="7-12月龄" :value="2"></el-option>
								<el-option label="13-26月龄" :value="3"></el-option>
								<el-option label="27-36月龄" :value="4"></el-option>
								<el-option label="37月龄以上" :value="5"></el-option>
							</el-select>
						</div>

						<!-- 0-6月龄start -->
						<div v-if="xueAddYueLingForm==1">

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>适应能力：</div>
								<div class="contentOne-content-text text-num">

									<start :isCanClick="true" ref="xueAddYueLingForm1a1" :startTotal="xueAddYueLingForm1.a1" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm1','a1')"></start>
									<div style="margin-top: 10px;">目标：在水中放松、爱笑</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title" style="margin-left: 14px;"><span style="color: red;">*</span>大运动：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm1a2" :startTotal="xueAddYueLingForm1.a2" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm1','a2')"></start>
									<div style="margin-top: 10px;">目标：自主踢腿意识及划手动作</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>手眼协调：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm1a3" :startTotal="xueAddYueLingForm1.a3" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm1','a3')"></start>
									<div style="margin-top: 10px;">目标：手眼协调配合能够抓取小玩具</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>适水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm1a4" :startTotal="xueAddYueLingForm1.a4" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm1','a4')"></start>
									<div style="margin-top: 10px;">目标：适水放松，闭气2秒以上，有明显口令意识</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>潜水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm1a5" :startTotal="xueAddYueLingForm1.a5" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm1','a5')"></start>
									<div style="margin-top: 10px;">目标：适水放松，潜水2秒以上，有明显口令意识</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>仰漂能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm1a6" :startTotal="xueAddYueLingForm1.a6" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm1','a6')"></start>
									<div style="margin-top: 10px;">目标：仰漂放松，能独立仰漂</div>
								</div>
							</div>

						</div>
						<!-- 0-6月龄end -->


						<!-- 7-12月龄start -->
						<div v-if="xueAddYueLingForm==2">

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>适应能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm2a1" :startTotal="xueAddYueLingForm2.a1" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm2','a1')"></start>
									<div style="margin-top: 10px;">目标：在水中放松、爱笑</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title" style="margin-left: 14px;"><span style="color: red;">*</span>大运动：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm2a2" :startTotal="xueAddYueLingForm2.a2" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm2','a2')"></start>
									<div style="margin-top: 10px;">目标：自主踢腿意识及划手动作</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>精细动作：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm2a3" :startTotal="xueAddYueLingForm2.a3" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm2','a3')"></start>
									<div style="margin-top: 10px;">目标：按指令完成抓握动作</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>适水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm2a4" :startTotal="xueAddYueLingForm2.a4" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm2','a4')"></start>
									<div style="margin-top: 10px;">目标：适水放松，闭气2秒以上，有明显口令意识</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>潜水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm2a5" :startTotal="xueAddYueLingForm2.a5" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm2','a5')"></start>
									<div style="margin-top: 10px;">目标：适水放松，潜水3秒以上，有明显口令意识，能独立潜水1秒</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title" style="margin-left: -1em;"><span style="color: red;">*</span>指令完成度：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm2a6" :startTotal="xueAddYueLingForm2.a6" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm2','a6')"></start>
									<div style="margin-top: 10px;">目标：根据指令完成动作，理解指令</div>
								</div>
							</div>



						</div>
						<!-- 7-12月龄end -->




						<!-- 13-26月龄start -->
						<div v-if="xueAddYueLingForm==3">

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>适应能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm3a1" :startTotal="xueAddYueLingForm3.a1" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm3','a1')"></start>
									<div style="margin-top: 10px;">目标：在水中放松、爱笑</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title" style="margin-left: 14px;"><span style="color: red;">*</span>大运动：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm3a2" :startTotal="xueAddYueLingForm3.a2" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm3','a2')"></start>
									<div style="margin-top: 10px;">目标：自主踢腿意识，有直膝交错踢腿动作</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title" style="margin-left: -1em;"><span style="color: red;">*</span>指令完成度：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm3a3" :startTotal="xueAddYueLingForm3.a3" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm3','a3')"></start>
									<div style="margin-top: 10px;">目标：根据指令完成动作，理解指令</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>适水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm3a4" :startTotal="xueAddYueLingForm3.a4" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm3','a4')"></start>
									<div style="margin-top: 10px;">目标：适水放松，闭气5秒以上，有明显口令意识</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>潜水能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm3a5" :startTotal="xueAddYueLingForm3.a5" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm3','a5')"></start>
									<div style="margin-top: 10px;">目标：适水放松，潜水3秒以上，有明显口令意识，能独立潜水2秒</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>认知能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm3a6" :startTotal="xueAddYueLingForm3.a6" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm3','a6')"></start>
									<div style="margin-top: 10px;">目标：认识简单的色彩、数字</div>
								</div>
							</div>


						</div>
						<!-- 13-26月龄end -->





						<!-- 27-36月龄start -->
						<div v-if="xueAddYueLingForm==4">

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>适应能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm4a1" :startTotal="xueAddYueLingForm4.a1" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm4','a1')"></start>
									<div style="margin-top: 10px;">目标：在水中放松、与教练表达意愿</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>踢腿动作：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm4a2" :startTotal="xueAddYueLingForm4.a2" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm4','a2')"></start>
									<div style="margin-top: 10px;">目标：直膝交错踢腿动作</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>呼吸控制：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm4a3" :startTotal="xueAddYueLingForm4.a3" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm4','a3')"></start>
									<div style="margin-top: 10px;">目标：稳定的进行吐泡泡，适水闭气5秒</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>身体控制：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm4a4" :startTotal="xueAddYueLingForm4.a4" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm4','a4')"></start>
									<div style="margin-top: 10px;">目标：手持A板进行自主抬头换气</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>安全自救：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm4a5" :startTotal="xueAddYueLingForm4.a5" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm4','a5')"></start>
									<div style="margin-top: 10px;">目标：有应激闭气动作，能够在水中进行自救上岸</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>划手能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm4a6" :startTotal="xueAddYueLingForm4.a6" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm4','a6')"></start>
									<div style="margin-top: 10px;">目标：直臂划手配合游进</div>
								</div>
							</div>
							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>配合练习：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm4a7" :startTotal="xueAddYueLingForm4.a7" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm4','a7')"></start>
									<div style="margin-top: 10px;">目标：潜水游进配合划手转头换气</div>
								</div>
							</div>




						</div>
						<!-- 27-36月龄end -->





						<!-- 37月龄以上start -->
						<div v-if="xueAddYueLingForm==5">

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>适应能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm5a1" :startTotal="xueAddYueLingForm5.a1" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm5','a1')"></start>
									<div style="margin-top: 10px;">目标：能独立完成任务，接受自己的成功和失败</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>踢腿动作：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm5a2" :startTotal="xueAddYueLingForm5.a2" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm5','a2')"></start>
									<div style="margin-top: 10px;">目标：直膝交错踢腿配合潜水游进</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>呼吸控制：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm5a3" :startTotal="xueAddYueLingForm5.a3" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm5','a3')"></start>
									<div style="margin-top: 10px;">目标：稳定进行换气，适水闭气8秒</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>身体控制：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm5a4" :startTotal="xueAddYueLingForm5.a4" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm5','a4')"></start>
									<div style="margin-top: 10px;">目标：手持A板进行自主抬头换气</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>安全自救：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm5a5" :startTotal="xueAddYueLingForm5.a5" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm5','a5')"></start>
									<div style="margin-top: 10px;">目标：有应激闭气动作，能够在水中进行自救上岸</div>
								</div>
							</div>

							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>划手能力：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm5a6" :startTotal="xueAddYueLingForm5.a6" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm5','a6')"></start>
									<div style="margin-top: 10px;">目标：直臂划手配合游进</div>
								</div>
							</div>
							<div class="contentOne-content">
								<div class="contentOne-content-title"><span style="color: red;">*</span>配合练习：</div>
								<div class="contentOne-content-text text-num">
									<start :isCanClick="true" ref="xueAddYueLingForm5a7" :startTotal="xueAddYueLingForm5.a7" @clickStart="clickStart" @click="clickStartBox('xueAddYueLingForm5','a7')"></start>
									<div style="margin-top: 10px;">目标：潜水游进配合划手转头换气</div>
								</div>
							</div>



						</div>
						<!-- 37月龄以上end -->


						<div class="contentOne-content">
							<div class="contentOne-content-title"><span style="color: red;">*</span>进阶计划：</div>
							<div class="contentOne-content-text text-num">

								<div>

									<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="xueAddJinJieForm" style="width: 540px;">
									</el-input>
								</div>
							</div>
						</div>

						<div class="contentOne-content">
							<div class="contentOne-content-title"><span style="color: red;">*</span>在家练习：</div>
							<div class="contentOne-content-text text-num">

								<div>

									<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="xueAddHomeForm" style="width: 540px;">
									</el-input>
								</div>
							</div>
						</div>



					</div>
					<!-- 一列start -->


				</div>
				<!-- 一行end -->



			</div>
			<div class="dis" style="justify-content: flex-end;">
				<el-button @click="addXueSave" round type="primary" size="mini">提交审核</el-button>
			</div>


		</el-dialog>
		<!--添加或修改的弹窗end-->




		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->


	</div>
</template>

<script>
	import exportObj from '@/components/excel/excelByHtml.js'
	import start from '../../components/start/start.vue';
	import uploadVideo from '../../components/upload/uploadVideo.vue';
	import uploadImg from '../../components/upload/uploadImg.vue';
	import {
		ajax
	} from '../../util/ajax.js';

	export default {
		name: '',
		components: {
			start,
			uploadVideo,
			uploadImg
		},
		data() {
			return {
				mobileWidth: window.mobileWidth + 20,
				isMobile: window.isMobile,
				mask: '', //操作备注
				addXueMobileByForm: '',
				addXueDatetimeByForm: '',
				xueAddOrEditTypeByForm: '',
				xueMobile: '', //学员手机号
				xueListTable: [],
				isShowDetail: false,
				currentRow: {},
				role: '',
				rowGoods_id: '', //列表项的商品id
				storeList: [], //门店列表
				isShowCollapse: false, //是否展开搜索项
				isShowAddOrEdit: false,
				isShowAdd: false,
				searchForm: {
					admin_id: '',
					video_status: "",
					status: ""
				},

				xueAddJinJieForm: '',
				xueAddHomeForm: '',
				xueAddVideoForm: [],
				xueAddImgForm: [],
				xueAddYueLingForm: '',
				xueAddYueLingForm1: { //0-6岁
					a1: 0,
					a2: 0,
					a3: 0,
					a4: 0,
					a5: 0,
					a6: 0,

				},

				xueAddYueLingForm2: { //7-12岁
					a1: 0,
					a2: 0,
					a3: 0,
					a4: 0,
					a5: 0,
					a6: 0,

				},

				xueAddYueLingForm3: { //13-26岁
					a1: 0,
					a2: 0,
					a3: 0,
					a4: 0,
					a5: 0,
					a6: 0,

				},

				xueAddYueLingForm4: { //27-36岁
					a1: 0,
					a2: 0,
					a3: 0,
					a4: 0,
					a5: 0,
					a6: 0,
					a7: 0

				},
				xueAddYueLingForm5: { //37岁以上
					a1: 0,
					a2: 0,
					a3: 0,
					a4: 0,
					a5: 0,
					a6: 0,
					a7: 0

				},

				pingLunByAdmin: '',
				isShowPingLunPop: false,
				pingLunInputValue: '', //评论的输入框内容
				pingLunInputPlaValue: '', //评论的输入框提示文字
				currentSentMsgItem: '',

				isShowPreImg: false, //是否显示浏览图片的弹窗
				preImgUrl: '', //浏览图片弹窗的图片地址


				tableHeight: 0, //表格高度
				loading: false,
				tableData: [], //表格数据
				pageNumber: 1, // 当前页数
				pageSize: 10, // 页面大小
				total: 0,

				shang: require("@/assets/shang.png"),
				xia: require("@/assets/xia.png"),
				sortIndex: -1, //排序项
				sortContent: '', //排序项的值 desc 或esc
				sortFlag: true, //排序箭头切换


				typeOptions: [], //分类列表
				currentStartNum: '',
				currentEidtRow: '',
				storeAdminUserList: [], //门店管理员列表
			}
		},

		filters: {
			//把 2021-07-30 11:07:36 格式为 07-30
			//								11:07
			//使用格式 <p>{{row.stateChangeTime | timeBreak(0)}}</p>    <p>{{row.stateChangeTime | timeBreak(1)}}</p> 
			timeBreak(time, type, from) {
				if (time) {
					return type == 0 ? (from == undefined ? time.substr(5, 5) : time.substr(0, 10)) : (type == 2 ? time
					.substr(0, 10) : (from == undefined ? time.substr(11, 5) : time.substr(11, 8)));
				} else {
					return time;
				}
			},

			timeBreak2(val) {

				let v = val.split(' ')[1];

				return v;
			},
			timeBreak1(val) {

				let v = val.split(' ')[0];

				return v;
			},

		},
		created() {
			this.getTableHeight();
		},
		mounted() {
			this.role = localStorage.getItem("role") ? localStorage.getItem("role").replace(/3alxi2fdksjfkljwijljsk128ldfln324kodnvjdsl32432jfiwefjls32432idaxpoife983iw2/g, '') : ''; //获取当前用户角色
			//挂载window.onresize事件(动态设置table高度)
			let _this = this;
			window.onresize = () => {
				if (_this.resizeFlag) {
					clearTimeout(_this.resizeFlag);
				}
				_this.resizeFlag = setTimeout(() => {
					_this.getTableHeight();
					_this.resizeFlag = null;
				}, 100);
			};
			if (this.role == 'hq_admin') {
				this.getStore();
			}

			this.initData();

			if (this.role == 'store_admin'||this.role=='store_sa') {
				this.getStoreList();
			}


		},

		methods: {
			
			
			//导出
			async exportXFnByHTML() {
			
				var searchForm = this.searchForm;
				
				
				if (searchForm.school_time === "" || searchForm.school_time === null) { //select未选中为空字符串
					searchForm.school_time = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				if (searchForm.create_time === "" || searchForm.create_time === null) { //select未选中为空字符串
					searchForm.create_time = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.school_time && searchForm.school_time.length > 0) {
					//日期重新赋值为时间戳日期
					let arr = searchForm.school_time;
					if (arr[0].getTime) {
						searchForm.school_time = [arr[0].getTime(), arr[1].getTime()];
					} else {
						searchForm.school_time = arr;
					}
				}
				
				if (searchForm.create_time && searchForm.create_time.length > 0) {
					//日期重新赋值为时间戳日期
					let arr = searchForm.create_time;
					if (arr[0].getTime) {
						searchForm.create_time = [arr[0].getTime(), arr[1].getTime()];
					} else {
						searchForm.create_time = arr;
					}
				}
				
				

				this.loading = true;
				let param = {
					...searchForm
				};
				
				if (searchForm.sort) {
					param.sort = searchForm.sort; //排序的属性名
					param.sort_rule = searchForm.sort_rule; //排序的方式
				}else{
					param.sort = undefined; //排序的属性名
					param.sort_rule = undefined; //排序的方式
				}
			
				let res = await ajax('/usertime/export', 'POST', param);
				const list = res.data.data.list;
			
				if (list.length == 0) {
					this.loading = false;
					this.$message.error('暂无导出信息~')
					return;
				}
			
			
			
			
			
				// tHeader和tbody的数据需要一一对应
				let tHeader = Object.keys(list[0]); //列头
				let tbody = list; //每列的列值
				//后面两个参数是图片宽度和高度,不建议导出图片，请求太慢
				exportObj.export2Excel(tHeader, tbody, '沐懿时刻.xls')
				this.loading = false;
			
			
			
			
			
			},

			async getStoreList() {
				let res = await ajax('/store/admin/list', 'GET', {
					page: 1,
					count: 1000
				});
				this.storeAdminUserList = res.data.data.admin;
			},

			allBtn() {
				this.searchForm.video_status = "";
				this.searchForm.admin_id = "";
				this.searchForm.status = "";
				this.handleSearch();
			},

			//发送评论
			async sendMsg() {


				if (!this.pingLunByAdmin) {
					this.$message.error('请输入评论内容');
					return;
				}

				console.log('this.currentRow', this.currentRow)
				let param = {
					usertime_id: this.currentRow.id,
					remark: this.pingLunByAdmin,
				};
				

				this.loading = true;
				let res = await ajax('/usertime/remark/add', 'POST', param);
				this.pingLunByAdmin = "";
				this.loading = false;
				this.$message({
					type: 'success',
					message: '评论成功'
				});
				this.showDetail(this.currentRow);




			},

			kePingSh() {
				this.searchForm.video_status = "";
				this.searchForm.admin_id = "";
				this.searchForm.status = 0;
				this.searchForm.new_remark = "";
				this.searchForm.no_reply_remark = "";
				this.handleSearch();

			},

			shipinSh() {
				this.searchForm.status = "";
				this.searchForm.video_status = 0;
				this.searchForm.new_remark = "";
				this.searchForm.no_reply_remark = "";
				this.handleSearch();
			},

			pingLunSh() {
				this.searchForm.status = "";
				this.searchForm.video_status = "";
				this.searchForm.new_remark = 1;
				this.searchForm.no_reply_remark = "";
				
				this.handleSearch();
			},
			huiFuSh() {
				this.searchForm.status = "";
				this.searchForm.video_status = "";
				this.searchForm.new_remark = "";
				this.searchForm.no_reply_remark = 1;
				
				console.log('this.searchForm.no_reply_remark',this.searchForm.no_reply_remark)

				this.handleSearch();
			},
			
			
			
			
			
			

			andOrEidtXueClose() {
				this.xueAddVideoForm = [];
				this.xueAddImgForm = [];
				this.xueAddJinJieForm = '';
				this.xueAddHomeForm = '';
				this.xueAddYueLingForm = '';
			},

			yueLingChange() {
				setTimeout(() => {
					console.log(111111)
					this.xueAddYueLingForm1 = { //0-6岁
						a1: 0,
						a2: 0,
						a3: 0,
						a4: 0,
						a5: 0,
						a6: 0,

					};

					this.xueAddYueLingForm2 = { //7-12岁
						a1: 0,
						a2: 0,
						a3: 0,
						a4: 0,
						a5: 0,
						a6: 0,

					};

					this.xueAddYueLingForm3 = { //13-26岁
						a1: 0,
						a2: 0,
						a3: 0,
						a4: 0,
						a5: 0,
						a6: 0,

					};

					this.xueAddYueLingForm4 = { //27-36岁
						a1: 0,
						a2: 0,
						a3: 0,
						a4: 0,
						a5: 0,
						a6: 0,
						a7: 0

					};
					this.xueAddYueLingForm5 = { //37岁以上
						a1: 0,
						a2: 0,
						a3: 0,
						a4: 0,
						a5: 0,
						a6: 0,
						a7: 0

					};

					if (this.xueAddYueLingForm == 1) {
						this.$refs.xueAddYueLingForm1a1.setStartTotal(0);
						this.$refs.xueAddYueLingForm1a2.setStartTotal(0);
						this.$refs.xueAddYueLingForm1a3.setStartTotal(0);
						this.$refs.xueAddYueLingForm1a4.setStartTotal(0);
						this.$refs.xueAddYueLingForm1a5.setStartTotal(0);
						this.$refs.xueAddYueLingForm1a6.setStartTotal(0);
					}

					if (this.xueAddYueLingForm == 2) {
						this.$refs.xueAddYueLingForm2a1.setStartTotal(0);
						this.$refs.xueAddYueLingForm2a2.setStartTotal(0);
						this.$refs.xueAddYueLingForm2a3.setStartTotal(0);
						this.$refs.xueAddYueLingForm2a4.setStartTotal(0);
						this.$refs.xueAddYueLingForm2a5.setStartTotal(0);
						this.$refs.xueAddYueLingForm2a6.setStartTotal(0);
					}

					if (this.xueAddYueLingForm == 3) {
						this.$refs.xueAddYueLingForm3a1.setStartTotal(0);
						this.$refs.xueAddYueLingForm3a2.setStartTotal(0);
						this.$refs.xueAddYueLingForm3a3.setStartTotal(0);
						this.$refs.xueAddYueLingForm3a4.setStartTotal(0);
						this.$refs.xueAddYueLingForm3a5.setStartTotal(0);
						this.$refs.xueAddYueLingForm3a6.setStartTotal(0);
					}

					if (this.xueAddYueLingForm == 4) {
						this.$refs.xueAddYueLingForm4a1.setStartTotal(0);
						this.$refs.xueAddYueLingForm4a2.setStartTotal(0);
						this.$refs.xueAddYueLingForm4a3.setStartTotal(0);
						this.$refs.xueAddYueLingForm4a4.setStartTotal(0);
						this.$refs.xueAddYueLingForm4a5.setStartTotal(0);
						this.$refs.xueAddYueLingForm4a6.setStartTotal(0);
						this.$refs.xueAddYueLingForm4a7.setStartTotal(0);
					}

					if (this.xueAddYueLingForm == 5) {
						this.$refs.xueAddYueLingForm5a1.setStartTotal(0);
						this.$refs.xueAddYueLingForm5a2.setStartTotal(0);
						this.$refs.xueAddYueLingForm5a3.setStartTotal(0);
						this.$refs.xueAddYueLingForm5a4.setStartTotal(0);
						this.$refs.xueAddYueLingForm5a5.setStartTotal(0);
						this.$refs.xueAddYueLingForm5a6.setStartTotal(0);
						this.$refs.xueAddYueLingForm5a7.setStartTotal(0);
					}

				}, 200)

			},
			clickStartBox(name1, name2) {
				this[name1][name2] = this.currentStartNum;


			},
			clickStart(val) {
				this.currentStartNum = val
				console.log(this)
			},
			resetXueYuanSK() {
				this.addXueMobileByForm = '';
				this.addXueDatetimeByForm = '';
				this.xueAddOrEditTypeByForm = '';
				this.xueMobile = ''; //学员手机号
				this.xueListTable = [];
				this.xueAddVideoForm = [];
				this.xueAddImgForm = [];
				this.xueAddJinJieForm = '';
				this.xueAddHomeForm = '';
				this.xueAddYueLingForm = '';
				this.xueAddYueLingForm1 = { //0-6岁
					a1: 0,
					a2: 0,
					a3: 0,
					a4: 0,
					a5: 0,
					a6: 0,

				};

				this.xueAddYueLingForm2 = { //7-12岁
					a1: 0,
					a2: 0,
					a3: 0,
					a4: 0,
					a5: 0,
					a6: 0,

				};

				this.xueAddYueLingForm3 = { //13-26岁
					a1: 0,
					a2: 0,
					a3: 0,
					a4: 0,
					a5: 0,
					a6: 0,

				};

				this.xueAddYueLingForm4 = { //27-36岁
					a1: 0,
					a2: 0,
					a3: 0,
					a4: 0,
					a5: 0,
					a6: 0,
					a7: 0

				};
				this.xueAddYueLingForm5 = { //37岁以上
					a1: 0,
					a2: 0,
					a3: 0,
					a4: 0,
					a5: 0,
					a6: 0,
					a7: 0

				};

			},
			//添加学员课时弹窗关闭
			addXueClose() {


				this.resetXueYuanSK();
				this.initData()
			},

			//门店审核是否通过
			async shenheTg(usertime_id, status) {
				let text = "确定审核通过吗？"
				if (status == 2) {
					text = "确定驳回吗？"
				}

				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true;
					let ress = await ajax('/store/usertime/check', 'PUT', {
						usertime_id,
						status,
						status_remark: this.currentRow.status_remark
					});
					this.loading = false;
					this.$message({
						type: 'success',
						message: '成功'
					});
					this.initData()
					this.isShowDetail = false;
				}).catch(() => {
					this.loading = false;
				});

			},


			//门店审核视频是否通过
			async shenheTgVideo(usertime_id, status) {
				let text = "确定视频审核通过吗？"
				if (status == 2) {
					text = "确定视频驳回吗？"
				}

				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true;
					let ress = await ajax('/store/usertime/check', 'PUT', {
						usertime_id,
						video_status: status,
						status_remark: this.currentRow.status_remark
					});
					this.loading = false;
					this.$message({
						type: 'success',
						message: '成功'
					});
					this.initData()
					this.isShowDetail = false;
				}).catch(() => {
					this.loading = false;
				});

			},

			//门店一键通过  
			async yiJianShenheTgVideo(usertime_id) {
				let text = "确定一键审核通过吗？"

				let param = {
					usertime_id,
					status_remark: this.currentRow.status_remark
				};


				if (this.currentRow.status == 0 || this.currentRow.status == 2) {
					param.status = 1;
				}

				if (this.currentRow.video && (this.currentRow.video_status == 0 || this.currentRow.video_status == 2)) {
					param.video_status = 1;
				}



				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true;
					let ress = await ajax('/store/usertime/check', 'PUT', param);
					this.loading = false;
					this.$message({
						type: 'success',
						message: '成功'
					});
					this.initData()
					this.isShowDetail = false;
				}).catch(() => {
					this.loading = false;
				});

			},

			//门店删除用户时刻项
			async delSK(usertime_id) {


				this.$confirm("确定删除吗？", '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true;
					let ress = await ajax('/store/usertime/delete', 'DELETE', {
						usertime_id
					});
					this.loading = false;
					this.$message({
						type: 'success',
						message: '成功'
					});
					this.initData()
				}).catch(() => {
					this.loading = false;
				});

			},
			//添加学员课时弹窗的保存
			async addXueSave() {
				let images = this.$refs.xueAddImgFormRef.getImgList();
				let xueAddHomeForm = this.xueAddHomeForm;
				let xueAddJinJieForm = this.xueAddJinJieForm;

				if (images.length == 0) {
					this.$message.error('请上传图片');
					return
				}
				if (!this.xueAddYueLingForm) {
					this.$message.error('请选择月龄');
					return
				}


				if (!xueAddJinJieForm) {
					this.$message.error('请填写进阶内容');
					return
				}

				if (!xueAddHomeForm) {
					this.$message.error('请在家练习内容');
					return
				}



				let scores = [];
				if (this.xueAddYueLingForm == 1) {
					scores.push(this.$refs.xueAddYueLingForm1a1.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm1a2.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm1a3.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm1a4.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm1a5.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm1a6.getStartTotal());
				}

				if (this.xueAddYueLingForm == 2) {
					scores.push(this.$refs.xueAddYueLingForm2a1.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm2a2.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm2a3.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm2a4.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm2a5.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm2a6.getStartTotal());
				}

				if (this.xueAddYueLingForm == 3) {
					scores.push(this.$refs.xueAddYueLingForm3a1.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm3a2.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm3a3.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm3a4.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm3a5.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm3a6.getStartTotal());
				}

				if (this.xueAddYueLingForm == 4) {
					scores.push(this.$refs.xueAddYueLingForm4a1.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm4a2.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm4a3.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm4a4.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm4a5.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm4a6.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm4a7.getStartTotal());
				}

				if (this.xueAddYueLingForm == 5) {
					scores.push(this.$refs.xueAddYueLingForm5a1.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm5a2.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm5a3.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm5a4.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm5a5.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm5a6.getStartTotal());
					scores.push(this.$refs.xueAddYueLingForm5a7.getStartTotal());
				}

				let contents = [xueAddJinJieForm, xueAddHomeForm];
				let stage = this.xueAddYueLingForm;
				let video = this.$refs.xueAddVideoFormRef.getVideoList();

				if (video.length == 0) {
					video = null;
				}


				//add edit
				//this.xueAddOrEditTypeByForm = type;
				let arr1 = [];
				if (video) {
					for (let s of video) {
						arr1.push(s.url)
					}
				}

				let arr2 = [];
				for (let s of images) {
					arr2.push(s.url)
				}
				console.log(this.addXueMobileByForm)
				let param = {};
				let url = ""
				let method = ''
				if (this.xueAddOrEditTypeByForm == 'add') {
					url = '/editor/usertime/add';
					method = "POST"
					param = {
						mobile: this.addXueMobileByForm,
						datetime: this.addXueDatetimeByForm,
						stage,
						video: arr1[0],
						images: arr2,
						scores,
						contents
					};
				}

				if (this.xueAddOrEditTypeByForm == 'edit') {
					url = '/editor/usertime/edit';
					method = "PUT"
					param = {
						usertime_id: this.currentEidtRow.id,

						stage,
						video: arr1[0],
						images: arr2,
						scores,
						contents
					};
				}

				this.loading = true;
				let ress = await ajax(url, method, param);
				this.loading = false;
				this.$message({
					message: '提交成功,请等待门店审核',
					type: 'success'
				});
				this.isShowAddOrEdit = false;

			},





















			//显示弹出输入框
			showPingLunPop(item) {

				let pingLunInputPlaValue = "";
				if (item.user) {
					pingLunInputPlaValue = '回复：' + item.user.nickname;
					this.currentSentMsgItem = item;

				}
				if (item.admin) {
					pingLunInputPlaValue = '回复：' + item.admin.nickname;
					this.currentSentMsgItem = item;
				}
				this.isShowPingLunPop = true;

				this.pingLunInputPlaValue = pingLunInputPlaValue;

			},
			onPingLunPopClose() {

				this.isShowPingLunPop = false;
				this.pingLunInputValue = ''; //评论的输入框内容
				this.pingLunInputPlaValue = ''; //评论的输入框提示文字
				this.currentSentMsgItem = '';

			},

			//发送回复
			async sendHuifu() {

				if (!this.pingLunInputValue.trim()) {

					this.$message.error('请输入回复内容');
					return;
				}

				console.log('this.currentRow', this.currentRow)
				let param = {
					usertime_id: this.currentRow.id,
					remark: this.pingLunInputValue,
				};
				if (this.currentSentMsgItem.user) {
					param.reply_user_id = this.currentSentMsgItem.user.id;
				}
				if (this.currentSentMsgItem.admin) {
					param.reply_admin_id = this.currentSentMsgItem.admin.id;
				}

				this.loading = true;
				let res = await ajax('/usertime/remark/add', 'POST', param);
				this.onPingLunPopClose();
				this.loading = false;
				this.$message({
					type: 'success',
					message: '回复成功'
				});
				this.showDetail(this.currentRow);

			},






























			//获取门店列表
			async getStore() {
				let ress = await ajax('/hq/store', 'GET');
				let res = ress.data.data;
				this.storeList = res.store;
			},

			//初始化表格数据
			async initData() {
				this.loading = true
				var searchForm = this.searchForm
				if (searchForm.store_id === "") { //select未选中为空字符串
					searchForm.store_id = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.new_remark === "") { //select未选中为空字符串
					searchForm.new_remark = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.no_reply_remark === "") { //select未选中为空字符串
					searchForm.no_reply_remark = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.mobile === "") { //select未选中为空字符串
					searchForm.mobile = undefined; //为null后就不会作为http请求参数了带给后端了
				}


				if (searchForm.etm_name === "") { //select未选中为空字符串
					searchForm.etm_name = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.etm_nickname === "") { //select未选中为空字符串
					searchForm.etm_nickname = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.status === "") { //select未选中为空字符串
					searchForm.status = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.video_status === "") { //select未选中为空字符串
					searchForm.video_status = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.admin_id === "") { //select未选中为空字符串
					searchForm.admin_id = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.school_time === "" || searchForm.school_time === null) { //select未选中为空字符串
					searchForm.school_time = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				if (searchForm.create_time === "" || searchForm.create_time === null) { //select未选中为空字符串
					searchForm.create_time = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.school_time && searchForm.school_time.length > 0) {
					//日期重新赋值为时间戳日期
					let arr = searchForm.school_time;
					if (arr[0].getTime) {
						searchForm.school_time = [arr[0].getTime(), arr[1].getTime()];
					} else {
						searchForm.school_time = arr;
					}
				}

				if (searchForm.create_time && searchForm.create_time.length > 0) {
					//日期重新赋值为时间戳日期
					let arr = searchForm.create_time;
					if (arr[0].getTime) {
						searchForm.create_time = [arr[0].getTime(), arr[1].getTime()];
					} else {
						searchForm.create_time = arr;
					}
				}

				let param = {
					// video_status: searchForm.video_status,
					// admin_id: searchForm.admin_id,
					// status: searchForm.status,
					// etm_name: searchForm.etm_name,
					// etm_nickname: searchForm.etm_nickname,
					// store_id: searchForm.store_id, //搜索的 门店id
					// new_remark: searchForm.new_remark,
					// no_reply_remark:searchForm.no_reply_remark,
					// mobile: searchForm.mobile, //搜索的 手机号
					// create_time: searchForm.create_time,
					// school_time: searchForm.school_time,
					...searchForm,


					count: this.pageSize,
					page: this.pageNumber
				}

				if (searchForm.sort) {
					param.sort = searchForm.sort; //排序的属性名
					param.sort_rule = searchForm.sort_rule; //排序的方式
				}else{
					param.sort = undefined; //排序的属性名
					param.sort_rule = undefined; //排序的方式
				}

				let ress = await ajax('/usertime/list', 'POST', param);
				this.loading = false;
				let res = ress.data.data;


				this.total = res.total;

				// for (let i of res.usertime) {

				// 	let num = 0;

				// 	for (let ii of i.remark) {


				// 		if (ii.remark) {
				// 			num += 1;
				// 		}


				// 	}


				// 	i.pinglunNum = num;
				// }


				this.tableData = res.usertime;




			},

			showAdd() {
				this.isShowAdd = true;
			},
			//添加弹窗上的搜索
			async xueMobileBySearch() {
				if (!this.xueMobile) {
					this.$message.error('请输入学员手机号');
					return
				}
				this.loading = true;
				let ress = await ajax('/editor/usertime/query', 'GET', {
					mobile: this.xueMobile
				});
				this.loading = false;
				let res = ress.data.data;
				this.xueListTable = res.record;


			},

			//添加时刻或编辑时刻,type= add edit
			async showAddOrEdit(row, type) {
				this.xueAddOrEditTypeByForm = type;
				this.addXueMobileByForm = this.xueMobile;
				this.addXueDatetimeByForm = row.date;
				if (type == 'edit') {
					this.loading = true;
					let ress = await ajax('/usertime/detail', 'GET', {
						usertime_id: row.id
					});
					this.loading = false;
					let res = ress.data.data;
					let currentEidtRow = res.usertime;
					this.currentEidtRow = currentEidtRow;
					this.xueAddYueLingForm = currentEidtRow.stage; //月龄
					if (currentEidtRow.video) {
						this.xueAddVideoForm = [{
							url: currentEidtRow.video
						}]; //视频

					}
					let arr = [];
					for (let s of currentEidtRow.images) {
						arr.push({
							url: s
						})
					}
					this.xueAddImgForm = arr; //图片
					this.xueAddJinJieForm = currentEidtRow.contents[0]; //进阶计划
					this.xueAddHomeForm = currentEidtRow.contents[1]; //在家计划

					if (this.xueAddYueLingForm == 1) {
						this.xueAddYueLingForm1 = { //0-6岁
							a1: Number(currentEidtRow.scores[0]),
							a2: Number(currentEidtRow.scores[1]),
							a3: Number(currentEidtRow.scores[2]),
							a4: Number(currentEidtRow.scores[3]),
							a5: Number(currentEidtRow.scores[4]),
							a6: Number(currentEidtRow.scores[5]),

						};
					}
					if (this.xueAddYueLingForm == 2) {
						this.xueAddYueLingForm2 = { //7-12岁
							a1: Number(currentEidtRow.scores[0]),
							a2: Number(currentEidtRow.scores[1]),
							a3: Number(currentEidtRow.scores[2]),
							a4: Number(currentEidtRow.scores[3]),
							a5: Number(currentEidtRow.scores[4]),
							a6: Number(currentEidtRow.scores[5]),

						};
					}
					if (this.xueAddYueLingForm == 3) {
						this.xueAddYueLingForm3 = { //13-26岁
							a1: Number(currentEidtRow.scores[0]),
							a2: Number(currentEidtRow.scores[1]),
							a3: Number(currentEidtRow.scores[2]),
							a4: Number(currentEidtRow.scores[3]),
							a5: Number(currentEidtRow.scores[4]),
							a6: Number(currentEidtRow.scores[5]),

						};
					}
					if (this.xueAddYueLingForm == 4) {
						this.xueAddYueLingForm4 = { //27-36岁
							a1: Number(currentEidtRow.scores[0]),
							a2: Number(currentEidtRow.scores[1]),
							a3: Number(currentEidtRow.scores[2]),
							a4: Number(currentEidtRow.scores[3]),
							a5: Number(currentEidtRow.scores[4]),
							a6: Number(currentEidtRow.scores[5]),
							a7: Number(currentEidtRow.scores[6])

						};
					}
					if (this.xueAddYueLingForm == 5) {
						this.xueAddYueLingForm5 = { //37岁以上
							a1: Number(currentEidtRow.scores[0]),
							a2: Number(currentEidtRow.scores[1]),
							a3: Number(currentEidtRow.scores[2]),
							a4: Number(currentEidtRow.scores[3]),
							a5: Number(currentEidtRow.scores[4]),
							a6: Number(currentEidtRow.scores[5]),
							a7: Number(currentEidtRow.scores[6])

						};
					}



				}


				this.isShowAddOrEdit = true;
			},

			//显示详情
			async showDetail(row) {
				this.loading = true;
				let ress = await ajax('/usertime/detail', 'GET', {
					usertime_id: row.id
				});
				this.loading = false;
				let res = ress.data.data;
				this.currentRow = res.usertime;
				this.isShowDetail = true;
			},
			//计算table高度(动态设置table高度)
			getTableHeight() {
				let tableH = 250; //距离页面下方的高度,值越大表格高度越小
				let tableHeightDetil = window.innerHeight - tableH;
				if (tableHeightDetil <= 300) {
					this.tableHeight = 300;
				} else {
					this.tableHeight = window.innerHeight - tableH;
				}
			},


			//展开搜索项
			isShowCollapseF() {
				this.isShowCollapse = !this.isShowCollapse;
			},
			//翻页
			changePage(pageNumber) {
				this.tableData = []; //这种可以让滚动条回到顶部
				this.pageNumber = pageNumber
				this.initData()
			},

			//点击头像
			handlePreView(url) {
				this.preImgUrl = url
				this.isShowPreImg = true
			},


			//排序 index是点击的项的索引,formName是属性名
			sort(index, formName) {
				//点击了默认排序
				if (index == -1) {
					this.sortIndex = -1;
					this.sortContent = ''; //排序的值 desc / esc
					this.sortFlag = true;
					//使用index把所有的搜索项值为''然后再发送请求获取到默认列表
					this.pageNumber = 1; //页码修改为1
					this.tableData = []; //表格数据修改为空
					this.searchForm.sort = ''; //排序的属性名
					this.searchForm.sort_rule = ''; //排序的方式
					//获取默认排序的表格数据

					this.initData(); //获取默认排序的表格数据
					return
				}
				//点击还是当前搜索项那么就进行升降序切换
				if (index == this.sortIndex) {
					this.sortFlag = !this.sortFlag;
					//把当前点击的搜索项切换为desc为降序
					if (this.sortFlag) {
						this.sortContent = 'desc'; //排序的值 desc / esc
						//使用index把所有的搜索项值为''然后把当前点击的搜索项的值修改为desc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName; //排序的属性名
						this.searchForm.sort_rule = 'desc'; //排序的方式
						//获取表格列表

						this.initData(); //获取当前点击的搜索项的表格数据
					} else {
						//把当前点击的搜索项切换为esc为升序
						//使用index把所有的搜索项值为''然后把当前搜索项的值修改为asc
						this.sortContent = 'asc'; //排序的值 desc / asc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName; //排序的属性名
						this.searchForm.sort_rule = 'asc'; //排序的方式
						//获取表格列表
						this.initData(); //获取当前点击的搜索项的表格数据
					}
					return
				}
				//当前点击的搜索项是其他的搜索项
				this.sortIndex = index; //当前点击的搜索项的索引号
				this.sortContent = 'desc'; //排序的值 desc / esc
				this.sortFlag = true;
				//使用index把所有的搜索项值为''然后把当前搜索项的值修改为desc然后再发送请求获取到列表
				this.pageNumber = 1; //页码修改为1
				this.tableData = []; //表格数据修改为空
				this.searchForm.sort = formName; //排序的属性名
				this.searchForm.sort_rule = 'desc'; //排序的方式
				//获取表格列表

				this.initData(); //获取当前点击的搜索项的排序的表格数据
			},



			//搜索
			handleSearch() {
				this.pageNumber = 1;
				this.initData()
			},

			//重置
			handleReset() {
				this.$refs.searchForm.resetFields();
				this.searchForm = {
					video_status: "",
					status: ""
				};
				this.sortIndex = -1;
				this.sortContent = ''; //排序的值 desc / esc
				this.sortFlag = true;
				this.pageNumber = 1
				this.pageSize = 10
				this.tableData = []; //表格数据修改为空
				this.initData()
			},






		}


	}
</script>

<style scoped>
	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;
		color: #2d8cf0;
		font-weight: 600;
	}

	.tableTem .avatar img {
		border-radius: 10px;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {

		padding-right: 20px;
		display: flex;
		justify-content: center;

	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.tableTem .dianL {
		text-align: left;
		font-size: 13px;
		color: #333;
	}


	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}





	.sortLine {
		display: flex;
		align-items: center;
	}

	.sortItem {

		height: 100%;
		color: rgb(156, 156, 156);
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		min-width: 100px;
	}

	.sortItem:hover {
		background-color: #9E819F !important;
		color: #fff !important;
	}

	.sortLine .sortItem:last-child {
		border-right: none;
	}

	>>>.el-table tbody tr:hover>td {
		background-color: #ffffff !important
	}


	>>>.el-icon-arrow-down {
		font-size: 12px;
	}

	>>>.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}

	>>>.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	>>>.el-table td {
		padding: 10px 0 !important;
	}






	.detal .title {
		color: #333333;
		margin-bottom: 24px;
		width: 100%;
		height: 16px;
		line-height: 16px;
		padding-left: 10px;
		border-left: 3px solid rgb(254, 106, 0);
		box-sizing: border-box;
		font-size: 15px;
		font-weight: bold;
	}

	.detal .order-detail {
		padding: 15px;
		box-sizing: border-box;
		background: white;
	}

	.detal .order-information>div:nth-child(1) {
		border-left: none;
	}

	.detal .order-information-contentOne {
		width: 50%;
		height: 100%;
		padding: 0 48px;
		box-sizing: border-box;
	}

	.detal .order-information {

		width: 100%;
		min-height: 40px;
		display: flex;
	}

	.detal .contentOne-content {
		display: flex;
		font-size: 14px;
		color: rgb(164, 164, 164);
		margin-bottom: 14px;
	}

	.detal .shop-information {
		width: 100%;
		background: white;
		padding: 15px;
		box-sizing: border-box;
		margin-top: 15px;
	}

	.detal .shop-information-table {
		width: 100%;
		padding: 0 48px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.detal .shop-information-table>table {
		width: 100%;
		border: 1px solid rgb(238, 238, 238);
		border-bottom: none;
	}

	.detal .table-trThree {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-top: 1px solid rgb(238, 238, 238);
		max-width: 100%;
		min-height: 40px;
		padding: 16px 28px;
		box-sizing: border-box;
		border: 1px solid rgb(238, 238, 238);
	}

	.detal .table-settlement {
		margin: 10px 0 20px;
		color: #333333;
		text-align: right;
	}

	.detal .table-trOne {
		height: 48px;
		background: rgb(245, 245, 245);
	}



	.detal .table-trTow {
		width: 100%;
		height: 60px;
		border-top: 1px solid rgb(238, 238, 238);
	}

	.detal .table-trTow>td {
		text-align: center;
		/* padding-left: 28px; */
		box-sizing: border-box;
		font-weight: 500;
		color: #333333;
		border-right: 1px solid rgb(238, 238, 238);
	}

	.detal .table-trThree>div {
		font-weight: 500;
		color: #333333;
	}

	.detal .contentOne-content-title {
		flex-shrink: 0;
	}

	.detal .table-trThree>div>p:nth-child(1) {
		margin-bottom: 8px;
	}

	.detal .table-trThree>div>p {
		color: rgb(164, 164, 164);
	}

	.detal .table-trThree>div>p {
		display: flex;
		align-items: center;
	}

	.detal .table-trThree>div>p>span {
		color: #333333;
	}

	.detal .table-settlement>span:nth-child(2) {
		color: rgb(255, 106, 0);
		font-size: 15px;
	}
</style>
